import React, { useEffect, useState } from "react";
import {
  ChevronRight,
  PlusIcon,
  EllipsisVertical,
  Trash2,
  Pencil,
} from "lucide-react";
import "./FeaturedCourses.css";
import Logo from "../../assets/image.png";
import AddFeaturedCourseModal from "./AddFeaturedCourseModal";
import apiServiceHandler from "../../service/apiService";
import { Shimmer } from "react-shimmer";
import toastr from "toastr";
import NewFeaturedCourse from "./NewFeaturedCourse";
import EditFeaturedCourseModal from "./EditFeaturedCourseModal";
import { useLocation } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { firestore } from "../../firebase";
import { handleUnreadCourseNotifications } from "../../redux/coursesData";
import { useDispatch, useSelector } from "react-redux";

const FeaturedCourses = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || null;
  const isAdmin = userDetails?.admin;
  const [loading, setLoading] = useState(true);
  const [featuredCoursesData, setFeaturedCoursesData] = useState([]);
  const [addFeaturedCourse, setAddFeaturedCourse] = useState(false);
  const [editFeaturedCourse, setEditFeaturedCourse] = useState(false);
  const [openPopover, setOpenPopover] = useState(null);
  const [refreshFeaturedCourse, setRefreshFeaturedCourse] = useState(false);
  const [editData, setEditData] = useState({});
  const location = useLocation();
  const dispatch = useDispatch();
  const unreadCourseNotifications = useSelector(
    (state) => state.coursesData.unreadCourseNotifications
  );

  const toggleFeaturedCourseModal = () => {
    setAddFeaturedCourse(!addFeaturedCourse);
  };

  const toggleEditFeaturedCourseModal = (data) => {
    setEditData(data);
    setEditFeaturedCourse(!editFeaturedCourse);
  };

  const togglePopover = (courseId) => {
    setOpenPopover(openPopover === courseId ? null : courseId);
  };

  const getFeaturedCourseData = async () => {
    try {
      setLoading(true);
      const response = await apiServiceHandler(
        "GET",
        "api/featured/courses",
        {}
      );
      if (response.status) {
        setFeaturedCoursesData(response.data);
      }
    } catch (error) {
      console.error(error.response);
    } finally {
      setLoading(false);
    }
  };

  const removeCourse = async (id) => {
    try {
      const response = await apiServiceHandler(
        "DELETE",
        `api/featured/courses/${id}`
      );
      if (response.status) {
        setFeaturedCoursesData((prevData) =>
          prevData.filter((course) => course._id !== id)
        );
        setRefreshFeaturedCourse(true);
        toastr.success(response.message);
      }
    } catch (error) {
      console.error("Error removing course:", error);
    }
  };

  useEffect(() => {
    getFeaturedCourseData();
    setRefreshFeaturedCourse(false);
  }, [refreshFeaturedCourse]);

  const updateReadStatus = async () => {
    const userId = userDetails?._id;
    if (!userId) return;

    const userRef = doc(firestore, "coursenotifications", userId);
    const userDoc = await getDoc(userRef);

    if (userDoc.exists()) {
      const data = userDoc.data();
      const notifications = data.notifications || [];

      const updatedNotifications = notifications.map((notification) => ({
        ...notification,
        read: true,
      }));

      dispatch(handleUnreadCourseNotifications(updatedNotifications));

      await updateDoc(userRef, { notifications: updatedNotifications });
    }
  };

  useEffect(() => {
    if (location.pathname === "/courses") {
      setTimeout(() => {
        updateReadStatus();
      }, 15000);
    }
  }, []);

  return (
    <div className="courses-page-section">
      <div className="courses-page-section-header">
        <div className="courses-header">
          <div className="courses-header-top">
            <div className="courses-header-content">
              <div className="courses-header-heading">
                Featured Courses and Programs
              </div>
              {/* 
              {userDetails && userDetails.admin &&
                <button className="add-content-btn" onClick={toggleFeaturedCourseModal}>
                  <span className="icon-plus">
                    <PlusIcon />
                  </span>
                  <span className="add-content-btn-label">Add</span>
                </button>
              }
              */}
            </div>
          </div>
        </div>
      </div>
      <div className="featured-page-section-body">
        {loading ? (
          <Shimmer number={4} />
        ) : featuredCoursesData && featuredCoursesData.length > 0 ? (
          featuredCoursesData.map((data, index) => (
            <div className="card-grid-container" key={data._id}>
              <div className="featured-card">
                <div className="featured-card__wrapper">
                  <div className="featured-card__image">
                    <img
                      src={data.thumbnail ? data.thumbnail : Logo}
                      alt="Course Thumbnail"
                    />
                  </div>
                  <div className="featured-card__heading">
                    <div>
                      {data.title}{" "}
                      {unreadCourseNotifications.length > 0 && unreadCourseNotifications?.some(
                        (notification) =>
                          notification.courseId === data._id &&
                          !notification.read
                      ) && (
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#26262f",
                            fontSize: "12px",
                            width: "fit-content",
                            height: "25px",
                            lineHeight: "1rem",
                            borderRadius: "10px",
                            textAlign: "center",
                            boxShadow: "2px 0px 12px #26262f",
                          }}
                        >
                          New Course
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="featured-card__content">
                    <div
                      className="courses-card__action"
                      style={{ paddingRight: "5px" }}
                    >
                      <a
                        href={
                          data.course_url.startsWith("http")
                            ? data.course_url
                            : `https://${data.course_url}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="courses-card__btn"
                      >
                        <span className="courses-card__btn">Visit</span>
                      </a>
                    </div>
                    {userDetails?.admin && (
                      <div
                        className="card__action-menu"
                        onMouseLeave={() => setOpenPopover(null)}
                      >
                        <button
                          className="btn-card-action"
                          onClick={() => togglePopover(data._id)}
                        >
                          <span className="icon--menu-dots">
                            <EllipsisVertical />
                          </span>
                        </button>
                        {openPopover === data._id && (
                          <div className="group-dropdown-popover">
                            <div className="group-dropdown-content">
                              <div
                                className="group-menu-item"
                                onClick={() =>
                                  toggleEditFeaturedCourseModal(data)
                                }
                              >
                                <span className="icon__settings">
                                  <Pencil
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      color: "#d1b794",
                                    }}
                                  />
                                </span>
                                <div className="group-menu-item__label">
                                  Edit
                                </div>
                              </div>
                              <div
                                className="group-menu-item"
                                onClick={() => removeCourse(data._id)}
                              >
                                <span className="icon__settings">
                                  <Trash2
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      color: "#d1b794",
                                    }}
                                  />
                                </span>
                                <div className="group-menu-item__label">
                                  Remove
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-courses-message">No Featured Course available</div>
        )}
        {isAdmin && (
          <NewFeaturedCourse
            toggleFeaturedCourseModal={toggleFeaturedCourseModal}
          />
        )}
      </div>
      <AddFeaturedCourseModal
        isOpen={addFeaturedCourse}
        onClose={toggleFeaturedCourseModal}
        setRefreshFeaturedCourse={setRefreshFeaturedCourse}
      />
      <EditFeaturedCourseModal
        isOpen={editFeaturedCourse}
        onClose={toggleEditFeaturedCourseModal}
        setRefreshFeaturedCourse={setRefreshFeaturedCourse}
        editData={editData}
      />
    </div>
  );
};

export default FeaturedCourses;
